import React from 'react';

import { useReportItemsFilter } from 'src/hooks/reports';

import { VERIFICATION_REQUESTS_TABLE_COLUMNS_CV_STAFF } from '../constants';

import { VerificationRequestsInnerTable } from './VerificationRequestsInnerTable';

export const VerificationRequestsTableCVAdmin: React.FC = () => {
  const { filter } = useReportItemsFilter();

  return (
    <VerificationRequestsInnerTable
      columns={VERIFICATION_REQUESTS_TABLE_COLUMNS_CV_STAFF}
      filter={filter}
    />
  );
};
